<script>
import { defineComponent, onMounted, onBeforeUnmount, ref } from 'vue'

export default defineComponent({
  name: 'VirtualListItemDynamicSize',
  emits: ['resized'],
  setup(_props, { emit, attrs }) {
    const itemRef = ref()
    // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
    const resizeObserver = new ResizeObserver(entries => {
      emit('resized', itemRef.value)
    })
    onMounted(() => {
      resizeObserver.observe(itemRef.value)
      //  emit('resized', itemRef.value)
    })
    onBeforeUnmount(() => {
      resizeObserver.disconnect()
    })
    return { itemRef }
  },
})
</script>

<template>
  <div
    ref="itemRef"
    class="resize-observe"
  >
    <slot />
  </div>
</template>
